import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getProducts = (params = {}) =>
  api.get("/products", { params }).then((r) => r.data);
export const getPreorders = () => api.get("/preorders").then((r) => r.data);
export const getConfig = () => api.get("/config").then((r) => r.data);
export const postWaitlist = (payload) => api.post("/waitlist", payload).then((r) => r.data);
export const postContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const postCheckout = (items) => api.post("/checkout", { items }).then((r) => r.data);
